import { Injectable } from '@angular/core';

import { LogContext } from './logger.types';

@Injectable({
  providedIn: 'root',
})
export abstract class Logger {
  public abstract debug(message: string, context?: LogContext): void;
  public abstract info(message: string, context?: LogContext): void;
  public abstract warn(message: string, context?: LogContext): void;
  public abstract error(message: string, context?: LogContext): void;
}
